module.exports = __webpack_public_path__ + "img/SKMJ_submit1.24e3b0b1.jpg";